<template>
  <v-row>
    <v-col>
      <general-error v-if="!!generalError" />
      <v-row class="px-3">
        <v-col cols="12" md="8" lg="6">
          <validatable-enum-combobox
              v-model="params.requestType"
              clearable
              :readonly="isLoading"
              :values-enum="LOT_REQUEST_TYPE_ENUM"
              :label="$t('Тип запроса')"
              @change="search" />
        </v-col>
      </v-row>
      <v-row class="px-3">
        <v-col>
          <paginated-data-table
              v-if="getLotRequests"
              ref="paginatedTable"
              :headers="headers"
              :items="requests"
              :loading="isLoading"
              item-key="requestId"
              :total-count="totalCount"
              :items-per-page="itemsPerPage"
              :request-method="getLotRequests">
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.requestType="{ item }">
              {{ $t(LOT_REQUEST_TYPE_ENUM[item.requestType]) }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.requestDate="{ item }">
              {{ item.requestDate
                ? $moment(item.requestDate).format('DD.MM.YYYY HH:mm')
                : null }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-if="isAdmin" v-slot:item.organizationName="{ item }">
              {{ item.organizationName }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <!-- <template v-slot:item.processDate="{ item }">
              {{ item.processDate
                ? $moment(item.processDate).format('DD.MM.YYYY HH:mm')
                : null }}
            </template> -->
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.status="{ item }">
              {{ $t(LOT_REQUEST_STATUS_ENUM[item.status]) }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.processComment="{ item }">
              {{ item.processComment }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.requestId="{ item }">
              <btn-icon-tip
                  v-if="isLotOwner(lot) || isAdmin"
                  icon="visibility"
                  :tip="$t('Просмотр запроса')"
                  @click="openRequestDialog(item.requestId)" />
            </template>
          </paginated-data-table>
        </v-col>
      </v-row>
      <request-dialog
          v-if="requestDialog.show"
          :dialog-prop="requestDialog"
          @close="closeDialog('requestDialog')" />
    </v-col>
  </v-row>
</template>

<script>

  import RequestDialog from './RequestDialog.vue'
  import PaginatedDataTable from '@/components/reused/ui/PaginatedDataTable.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import ValidatableEnumCombobox from '@/components/reused/ui/ValidatableEnumCombobox.vue'
  import { LOT_REQUEST_STATUS_ENUM, LOT_REQUEST_TYPE_ENUM } from '@/constants/enums'
  import { mapActions, mapState } from 'vuex'
  import { LOT_REQUESTS_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      RequestDialog,
      PaginatedDataTable,
      BtnIconTip,
      ValidatableEnumCombobox,
      GeneralError
    },
    props: {
      lot: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        LOT_REQUEST_STATUS_ENUM,
        LOT_REQUEST_TYPE_ENUM,
        isLoading: false,
        itemsPerPage: 10,
        requestDialog: {
          show: false,
          lotId: null,
          lotType: null,
          requestId: null
        },
        params: {
          requestType: ''
        }
      }
    },
    computed: {
      ...mapState(LOT_REQUESTS_MANAGEMENT.NAMESPACE, {
        requestsInfo: state => (state[LOT_REQUESTS_MANAGEMENT.STATE.REQUESTS] || { })
      }),
      headers () {
        let headers = [
          { text: this.$t('Тип запроса'), align: 'start', sortable: false, value: 'requestType' },
          { text: this.$t('Дата подачи запроса'), align: 'start', sortable: false, value: 'requestDate' },
          { text: this.$t('Организация'), align: 'start', sortable: false, value: 'organizationName' },
          // { text: this.$t('Дата обработки запроса'), align: 'start', sortable: false, value: 'processDate' },
          { text: this.$t('Текущий статус'), align: 'start', sortable: false, value: 'status' },
          { text: this.$t('Комментарий'), align: 'start', sortable: false, value: 'processComment' },
          { text: this.$t('Действия'), align: 'start', sortable: false, value: 'requestId' }
        ]

        if (!this.isAdmin) {
          headers = headers.filter(h => h.value !== 'organizationName')
        }

        return headers
      },
      totalCount () {
        return this.requestsInfo.totalCount || 0
      },
      requests () {
        return this.requestsInfo.items || []
      }
    },
    // watch: {
    //   lot: {
    //     immediate: true,
    //     handler (newVal, oldVal) {
    //       if (newVal.lotId) {
    //         this.$refs.paginatedTable.getDataFromServer()
    //       }
    //     }
    //   }
    // },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(LOT_REQUESTS_MANAGEMENT.NAMESPACE, {
        getLotRequestsAction: LOT_REQUESTS_MANAGEMENT.ACTIONS.GET_LOT_REQUESTS,
        clearLotRequestsAction: LOT_REQUESTS_MANAGEMENT.ACTIONS.CLEAR_LOT_REQUESTS
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearLotRequestsAction()
          ])
      },
      search: async function () {
        await this.$refs.paginatedTable.resetPaginationAndGetDataFromServer()
      },
      getLotRequests: async function (params) {
        try {
          this.isLoading = true
          await this.getLotRequestsAction({
            params: {
              ...params,
              ...this.params
            },
            lotId: this.lot.lotId,
            lotType: this.lot.lotType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      openRequestDialog: function (requestId) {
        this.requestDialog.requestId = requestId
        this.requestDialog.lotId = this.lot.lotId
        this.requestDialog.lotType = this.lot.lotType
        this.requestDialog.show = true
      }
    }
  }
</script>
